import { Injectable } from '@angular/core';
import { SnackbarContainerComponent } from '../../shared/components/snackbar/snackbar-container.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private container: SnackbarContainerComponent | null = null;

  show(
    text: string,
    type: 'success' | 'error' | 'info' = 'info',
    timeout = 3000
  ) {
    if (this.container) {
      // Use the new container-based approach
      this.container.addSnackbar(text, type, timeout);
    } else {
      // Fallback to old dialog-based approach if no container is set
      console.warn(
        'SnackbarContainer not available, snackbar may not display correctly'
      );
    }
  }

  setContainer(container: SnackbarContainerComponent | null): void {
    this.container = container;
  }
}
